// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 직원 검색 컴포넌트 스타일 */
.employee-search {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: white;
}

.search-header {
  padding: 1rem;
  border-bottom: 1px solid #e1e5e9;
  background: #f8f9fa;
}

.header-top {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

/* .back-btn 공통 스타일(components.css)은 아이콘 전용 28px 고정 —
   이 화면은 텍스트 버튼("← 기업 선택")이므로 크기 재정의 */
.employee-search .back-btn {
  width: auto;
  height: auto;
  padding: 0.4rem 0.8rem;
  font-size: 0.85rem;
  white-space: nowrap;
}

.search-header h3 {
  color: #495057;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.company-info {
  margin-bottom: 0.5rem;
}

.company-name {
  color: #007bff;
  font-weight: 600;
  font-size: 1rem;
}

.company-alt-name {
  color: #6c757d;
  font-size: 0.9rem;
  margin-left: 0.5rem;
}

.search-stats {
  color: #6c757d;
  font-size: 0.85rem;
}

.period-controls {
  padding: 1rem;
  border-bottom: 1px solid #e1e5e9;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.period-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.period-label {
  color: #495057;
  font-weight: 500;
  font-size: 0.9rem;
}

.period-select {
  padding: 0.5rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 6px;
  background: white;
  color: #495057;
  font-size: 0.9rem;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.period-select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.contract-type-group {
  display: flex;
  align-items: center;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  color: #495057;
  font-size: 0.9rem;
  font-weight: 500;
}

.contract-type-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.checkbox-text {
  -webkit-user-select: none;
          user-select: none;
}

.search-controls {
  padding: 1rem;
  border-bottom: 1px solid #e1e5e9;
  background: white;
}

.search-input-group {
  position: relative;
  margin-bottom: 1rem;
}

.search-input {
  width: 100%;
  padding: 0.75rem 2.5rem 0.75rem 1rem;
  border: 1px solid #ced4da;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: border-color 0.2s ease;
}

.search-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.clear-search-btn {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.25rem;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.clear-search-btn:hover {
  background: #e9ecef;
  color: #495057;
}


.employee-results {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain; /* 목록 끝에서 스크롤이 본문으로 번지지 않게 */
  padding: 0.5rem;
}

.employee-results::-webkit-scrollbar {
  width: 10px;
}

.employee-results::-webkit-scrollbar-track {
  background: #f1f3f5;
  border-radius: 5px;
}

.employee-results::-webkit-scrollbar-thumb {
  background: #adb5bd;
  border-radius: 5px;
  border: 2px solid #f1f3f5;
}

.employee-results::-webkit-scrollbar-thumb:hover {
  background: #868e96;
}

.employee-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.employee-item {
  background: white;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  padding: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.employee-item:hover {
  border-color: #007bff;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);
}

.employee-item.selected {
  border-color: #007bff;
  background: #f8f9ff;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.15);
}

.employee-content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.employee-main-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.employee-name {
  color: #212529;
  font-weight: 600;
  font-size: 1rem;
}

.employee-id {
  color: #495057;
  font-size: 0.9rem;
  font-family: monospace;
}


.employee-contract {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.85rem;
}

.contract-type {
  background: #f8f9fa;
  color: #495057;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-weight: 500;
}


.no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  text-align: center;
  color: #6c757d;
}

.no-results-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.no-results p {
  margin: 0.25rem 0;
  font-size: 0.9rem;
}

.no-results-hint {
  font-size: 0.8rem !important;
  color: #adb5bd !important;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
  .search-header {
    padding: 0.75rem;
  }
  
  .header-top {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .back-btn {
    font-size: 0.8rem;
    padding: 0.4rem 0.8rem;
  }
  
  .search-header h3 {
    font-size: 1.1rem;
  }
  
  .period-controls {
    padding: 0.75rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .search-controls {
    padding: 0.75rem;
  }
  
  
  .employee-item {
    padding: 0.75rem;
  }
  
  .employee-main-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .employee-contract {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}

@media (max-width: 480px) {
  .search-header {
    padding: 0.5rem;
  }
  
  .period-controls {
    padding: 0.5rem;
  }
  
  .search-controls {
    padding: 0.5rem;
  }
  
  .employee-item {
    padding: 0.5rem;
  }
  
  .employee-name {
    font-size: 0.9rem;
  }
  
  .employee-id {
    font-size: 0.8rem;
  }
}

/* 조회 기간 토글: 누르면 바로 바뀐다 */
.period-toggle { display: inline-flex; flex-wrap: wrap; }
.period-toggle button {
  padding: 3px 8px;
  margin-left: -1px;
  border: 1px solid #ced4da;
  background: #fff;
  color: #495057;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}
.period-toggle button:first-child { margin-left: 0; border-radius: 5px 0 0 5px; }
.period-toggle button:last-child { border-radius: 0 5px 5px 0; }
.period-toggle button:hover:not(.on) { background: #f1f3f5; }
.period-toggle button.on { position: relative; border-color: #1864ab; background: #1864ab; color: #fff; font-weight: 600; }
`, "",{"version":3,"sources":["webpack://./src/components/EmployeeSearch.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;sCACsC;AACtC;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,4BAA4B,EAAE,4BAA4B;EAC1D,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,yBAAyB;AACzB,iBAAiB,oBAAoB,EAAE,eAAe,EAAE;AACxD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,eAAe;AACjB;AACA,oCAAoC,cAAc,EAAE,0BAA0B,EAAE;AAChF,mCAAmC,0BAA0B,EAAE;AAC/D,uCAAuC,mBAAmB,EAAE;AAC5D,2BAA2B,kBAAkB,EAAE,qBAAqB,EAAE,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE","sourcesContent":["/* 직원 검색 컴포넌트 스타일 */\r\n.employee-search {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: white;\r\n}\r\n\r\n.search-header {\r\n  padding: 1rem;\r\n  border-bottom: 1px solid #e1e5e9;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.header-top {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n/* .back-btn 공통 스타일(components.css)은 아이콘 전용 28px 고정 —\r\n   이 화면은 텍스트 버튼(\"← 기업 선택\")이므로 크기 재정의 */\r\n.employee-search .back-btn {\r\n  width: auto;\r\n  height: auto;\r\n  padding: 0.4rem 0.8rem;\r\n  font-size: 0.85rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n.search-header h3 {\r\n  color: #495057;\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  margin: 0;\r\n}\r\n\r\n.company-info {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.company-name {\r\n  color: #007bff;\r\n  font-weight: 600;\r\n  font-size: 1rem;\r\n}\r\n\r\n.company-alt-name {\r\n  color: #6c757d;\r\n  font-size: 0.9rem;\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n.search-stats {\r\n  color: #6c757d;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.period-controls {\r\n  padding: 1rem;\r\n  border-bottom: 1px solid #e1e5e9;\r\n  background: #f8f9fa;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n}\r\n\r\n.period-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.period-label {\r\n  color: #495057;\r\n  font-weight: 500;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.period-select {\r\n  padding: 0.5rem 0.75rem;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 6px;\r\n  background: white;\r\n  color: #495057;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\n.period-select:focus {\r\n  outline: none;\r\n  border-color: #007bff;\r\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\r\n}\r\n\r\n.contract-type-group {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.checkbox-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  cursor: pointer;\r\n  color: #495057;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.contract-type-checkbox {\r\n  width: 16px;\r\n  height: 16px;\r\n  cursor: pointer;\r\n}\r\n\r\n.checkbox-text {\r\n  user-select: none;\r\n}\r\n\r\n.search-controls {\r\n  padding: 1rem;\r\n  border-bottom: 1px solid #e1e5e9;\r\n  background: white;\r\n}\r\n\r\n.search-input-group {\r\n  position: relative;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.search-input {\r\n  width: 100%;\r\n  padding: 0.75rem 2.5rem 0.75rem 1rem;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 8px;\r\n  font-size: 0.9rem;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\n.search-input:focus {\r\n  outline: none;\r\n  border-color: #007bff;\r\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\r\n}\r\n\r\n.clear-search-btn {\r\n  position: absolute;\r\n  right: 0.75rem;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: none;\r\n  border: none;\r\n  color: #6c757d;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  padding: 0.25rem;\r\n  border-radius: 50%;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.clear-search-btn:hover {\r\n  background: #e9ecef;\r\n  color: #495057;\r\n}\r\n\r\n\r\n.employee-results {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain; /* 목록 끝에서 스크롤이 본문으로 번지지 않게 */\r\n  padding: 0.5rem;\r\n}\r\n\r\n.employee-results::-webkit-scrollbar {\r\n  width: 10px;\r\n}\r\n\r\n.employee-results::-webkit-scrollbar-track {\r\n  background: #f1f3f5;\r\n  border-radius: 5px;\r\n}\r\n\r\n.employee-results::-webkit-scrollbar-thumb {\r\n  background: #adb5bd;\r\n  border-radius: 5px;\r\n  border: 2px solid #f1f3f5;\r\n}\r\n\r\n.employee-results::-webkit-scrollbar-thumb:hover {\r\n  background: #868e96;\r\n}\r\n\r\n.employee-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.employee-item {\r\n  background: white;\r\n  border: 1px solid #e1e5e9;\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.employee-item:hover {\r\n  border-color: #007bff;\r\n  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);\r\n}\r\n\r\n.employee-item.selected {\r\n  border-color: #007bff;\r\n  background: #f8f9ff;\r\n  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.15);\r\n}\r\n\r\n.employee-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.employee-main-info {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.employee-name {\r\n  color: #212529;\r\n  font-weight: 600;\r\n  font-size: 1rem;\r\n}\r\n\r\n.employee-id {\r\n  color: #495057;\r\n  font-size: 0.9rem;\r\n  font-family: monospace;\r\n}\r\n\r\n\r\n.employee-contract {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.contract-type {\r\n  background: #f8f9fa;\r\n  color: #495057;\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 4px;\r\n  font-weight: 500;\r\n}\r\n\r\n\r\n.no-results {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 200px;\r\n  text-align: center;\r\n  color: #6c757d;\r\n}\r\n\r\n.no-results-icon {\r\n  font-size: 3rem;\r\n  margin-bottom: 1rem;\r\n  opacity: 0.5;\r\n}\r\n\r\n.no-results p {\r\n  margin: 0.25rem 0;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.no-results-hint {\r\n  font-size: 0.8rem !important;\r\n  color: #adb5bd !important;\r\n}\r\n\r\n/* 반응형 디자인 */\r\n@media (max-width: 768px) {\r\n  .search-header {\r\n    padding: 0.75rem;\r\n  }\r\n  \r\n  .header-top {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .back-btn {\r\n    font-size: 0.8rem;\r\n    padding: 0.4rem 0.8rem;\r\n  }\r\n  \r\n  .search-header h3 {\r\n    font-size: 1.1rem;\r\n  }\r\n  \r\n  .period-controls {\r\n    padding: 0.75rem;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .search-controls {\r\n    padding: 0.75rem;\r\n  }\r\n  \r\n  \r\n  .employee-item {\r\n    padding: 0.75rem;\r\n  }\r\n  \r\n  .employee-main-info {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .employee-contract {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.5rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .search-header {\r\n    padding: 0.5rem;\r\n  }\r\n  \r\n  .period-controls {\r\n    padding: 0.5rem;\r\n  }\r\n  \r\n  .search-controls {\r\n    padding: 0.5rem;\r\n  }\r\n  \r\n  .employee-item {\r\n    padding: 0.5rem;\r\n  }\r\n  \r\n  .employee-name {\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .employee-id {\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n\r\n/* 조회 기간 토글: 누르면 바로 바뀐다 */\r\n.period-toggle { display: inline-flex; flex-wrap: wrap; }\r\n.period-toggle button {\r\n  padding: 3px 8px;\r\n  margin-left: -1px;\r\n  border: 1px solid #ced4da;\r\n  background: #fff;\r\n  color: #495057;\r\n  font: inherit;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n}\r\n.period-toggle button:first-child { margin-left: 0; border-radius: 5px 0 0 5px; }\r\n.period-toggle button:last-child { border-radius: 0 5px 5px 0; }\r\n.period-toggle button:hover:not(.on) { background: #f1f3f5; }\r\n.period-toggle button.on { position: relative; border-color: #1864ab; background: #1864ab; color: #fff; font-weight: 600; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
